import React, { useEffect, useState } from "react";
import axiosInstance from "../../../../axios";
import { getPaginatedData } from "../../../../_helpers";
import { Loading } from "../../../Other/Loading";
import Pagination from "./Pagination";
const { REACT_APP_PAYMENT_API_BASEURL } = process.env;

const MonthReport = () => {
  const [MonthData, setMonthData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const { data, startIndex, totalPageCount } = getPaginatedData(
    MonthData,
    currentPage
  );

  

  useEffect(() => {
    const fetch = () => {
      axiosInstance
        .get(`${REACT_APP_PAYMENT_API_BASEURL}/v2/monthly-course-report`)
        .then((res) => {
          setMonthData(res?.data?.data);
        })
        .catch((error) => {
          console.log(error);
        });
    };
    fetch();
  }, []);
  
  return (
    <div className="width-0">
      <div className="dashboard-container-new">
        <p>Month Wise Report</p>
        <div>
          <button className="lastmonth-btn">Last Month</button>
          <button className="export-btn">Export</button>
        </div>
      </div>

      <div className="page-data-new">
        {
        // data?.length > 0 ? (
        //   <p className="showing-result">
        //     Showing page {currentPage} of {totalPageCount} results
        //   </p>
        // ) :
         (
          <p className="showing-result">Showing 0 result</p>
        )}
      </div>

      <div className="instructor-table">
        {
        data?.length === 0 ? (
          <Loading />
        ) : 
        (
          <table className="table-width-100">
            <thead>
              <tr>
                <th>S.no</th>
                <th>Month</th>
                <th>Student Enrolled</th>
                <th>Instructor Enrolled</th>
                <th>Course Created</th>
                <th>Courses Purchased</th>
                <th>Bundle Purchased</th>
              </tr>
            </thead>
            {/* <tbody>
              {
              data.map((ele, index) => {
                return (
                  <tr key={index}>
                    <td className="cell">{startIndex + index}</td>
                    <td className="cell">
                      {ele?.Month === null ? "-" : ele.Month}
                    </td>
                    <td className="cell">
                      {ele?.Students === null || !ele.Students
                        ? "-"
                        : ele.Students}
                    </td>
                    <td className="cell">
                      {ele?.Instructors === null || !ele.Instructors
                        ? "-"
                        : ele.Instructors}
                    </td>
                    <td className="cell">
                      {ele?.CourseCreated === null || !ele.CourseCreated
                        ? "-"
                        : ele.CourseCreated}
                    </td>
                    <td className="cell">
                      {ele?.CoursesPurchased === null || !ele.CoursesPurchased
                        ? "-"
                        : ele.CoursesPurchased}
                    </td>
                    <td className="cell">
                      {ele.BundlePurchased === null || !ele.BundlePurchased
                        ? "-"
                        : ele.CoursesPurchased}
                    </td>
                  </tr>
                );
              })}
            </tbody> */}
          </table>
        )}
      </div>
      <div className="pageNumbers-sudents">
        {/* <Pagination
          className="pageNumbers-sudents"
          currentPage={currentPage}
          totalCount={10}
          pageSize={totalPageCount}
          onPageChange={(page) => setCurrentPage(page)}
        /> */}
      </div>
    </div>
  );
};

export default MonthReport;
